<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <v-dialog
        v-model="dialog"
        persistent
        id="editUser"
        width="500px"
        :fullscreen="$vuetify.breakpoint.xsOnly"
    >
        <v-card :loading="loading">
            <template slot="progress">
                <v-progress-linear
                    height="10"
                    indeterminate
                ></v-progress-linear>
            </template>
            <v-card-title class="py-6">
                <div
                    class="text-h6 text-sm-h4"
                    style="word-break: break-word;"
                >{{ language.t('EditUser.editUser') }}</div>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    color="blue darken-1"
                    @click="$emit('close');"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    v-on:submit.prevent="updateUser"
                >
                    <v-text-field
                        v-model="form.firstName"
                        :label="language.t('Forms.firstName')"
                        :disabled="loading"
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="form.middleName"
                        :label="language.t('Forms.middleName')"
                        :disabled="loading"
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="form.lastName"
                        :label="'*' + language.t('Forms.lastName')"
                        required
                        :rules="nameRules"
                        :disabled="loading"
                    >
                    </v-text-field>
                    <v-text-field
                        v-model="form.emailAddress"
                        :label="'*' + language.t('Forms.emailAddress')"
                        required
                        disabled
                    ></v-text-field>
                    <v-text-field
                        v-model="form.mobilePhoneNumber"
                        :label="language.t('Forms.phoneNumber')"
                        :disabled="loading"
                    />
                    <v-checkbox v-if="$auth.subscription == '__SUB_CIVIL_VECTOR'"
                        v-model="form.mailNotif"
                        :label="language.t('Vector.MailNotifications')"
                        :disabled="loading"
                        :true-value="true"
                        :false-value="false"
                    />
                    <v-checkbox v-if="$auth.subscription == '__SUB_CIVIL_VECTOR'"
                        v-model="form.smsNotif"
                        :label="language.t('Vector.SMSNotifications')"
                        :disabled="loading"
                        :true-value="true"
                        :false-value="false"
                    />
                    <p class="text-right">* = {{ language.t('Forms.requiredFields') }}</p>
                    <v-btn
                        color="success"
                        class="mr-4"
                        type="submit"
                        :disabled="!complete"
                        :loading="saving"
                    >
                        {{ language.t('App.save') }}
                    </v-btn>
                </v-form>
            </v-card-text>
            <v-card-actions class="card-actions">
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="$emit('close');"
                >
                    <v-icon>mdi-close</v-icon>{{ language.t('App.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    components: {
    },
    props: { userAccountId: null },
    data() {
        return {
            dialog: true,
            valid: true,
            complete: false,
            loading: true,
            saving: false,
            error: null,
            success: false,

            nameRules: [
                v => !!v || 'Een achternaamnaam is vereist',
            ],
            passwordRules: [
                v => !!v || "Wachtwoord is vereist.",
            ],
            form: {
                firstName: "",
                middleName: "",
                lastName: "",
                emailAddress: "",
                mobilePhoneNumber: "",
                mailNotif: false,
                smsNotif: false
            },
            userId: ""
        };
    },
    mounted: function () {
        this.getUser();
    },
    computed: {

    },
    watch: {
        form: {
            /* validate if the form data is complete */
            handler(val) {
                if (val.lastName != "")
                    this.complete = true;
                else
                    this.complete = false;
            },
            deep: true
        }
    },
    methods: {
        getUser() {
            var component = this;
            component.items = [];
            component.loading = true;

            this.$axios.get(route('api.user.customer.user', [this.userAccountId]))
                .then((res) => {
                    component.form.firstName = res.data.firstName;
                    component.form.middleName = res.data.middleName;
                    component.form.lastName = res.data.lastName;
                    component.form.emailAddress = res.data.emailAddress;
                    component.form.mobilePhoneNumber = res.data.mobilePhoneNumber;

                    component.loading = false;
                    this.userId = res.data.userId;
                    this.$axios.get(route('api.user.preference', this.userId)).then((res) =>{
                        component.form.mailNotif = (res.data.mail_notif === 1);
                        component.form.smsNotif = (res.data.sms_notif === 1);
                    });
                });

           
        },
        updateUser() {
            console.log(this.form.emailAddress);
            this.saving = true;
            this.error = null;
            let data = new FormData();

            //required data
            data.set('lastName', this.form.lastName);
            data.set('password', this.form.password);

            //optional data
            this.form.firstName && data.set('firstName', this.form.firstName);
            this.form.middleName && data.set('middleName', this.form.middleName);
            this.form.mobilePhoneNumber && data.set('mobilePhoneNumber', this.form.mobilePhoneNumber);

            this.$axios.post(route('api.user.customer.user.update', this.userAccountId), data, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((res) => {
                    this.success = true;
                    this.saving = false;
                    this.$emit("update");
                    this.$emit("close");
                })
                .catch((error) => {
                    this.saving = false;
                    console.log(error.response.data);
                    if (error.response.data.error)
                        this.error = error.response.data.error;
                    else
                        this.error = "unknown server error";
                });
            console.log(this.form.mailNotif);
            console.log(this.form.smsNotif);
            this.$axios.post(route('api.user.preference.update',[this.userId, this.form.mailNotif.toString(), this.form.smsNotif.toString()]));
        },
        onClose() {
            this.$emit("close");
        },
    },
};
</script>
<style scoped></style>
